export default "__VITE_PUBLIC_ASSET__287baf36__"